// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-list-component .status-3 {
	background-color: #4b4b4b;
	opacity: .5;
}

.project-list-component .status-7 {
	background-color: #3b1f1f;
	opacity: .5;
}`, "",{"version":3,"sources":["webpack://./src/components/projectList/style.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ","sourcesContent":[".project-list-component .status-3 {\r\n\tbackground-color: #4b4b4b;\r\n\topacity: .5;\r\n}\r\n\r\n.project-list-component .status-7 {\r\n\tbackground-color: #3b1f1f;\r\n\topacity: .5;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
